/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";

try {
  const colorScheme = localStorage.getItem("mantine-color-scheme") || "auto";
  let computedColorScheme = colorScheme;
  if (colorScheme === "auto") {
    computedColorScheme = window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }
  document.documentElement.setAttribute("data-mantine-color-scheme", computedColorScheme);
} catch (_e) {}

const elem = document.getElementById("root");
const app = <App />;

if (!elem) {
  throw new Error("React app root container doesn't exist.");
}
if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  // biome-ignore lint/suspicious/noAssignInExpressions: approved by developer
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(<StrictMode>{app}</StrictMode>);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
